import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-form-input-text',
  templateUrl: './form-input-text.component.html',
  styleUrls: ['./form-input-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputTextComponent),
      multi: true
    }
  ]
})
export class FormInputTextComponent implements OnInit, ControlValueAccessor {
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() label: string;

  public id: string;

  public onChange = (_: any) => {
  }
  public onTouch = () => {
  }

  constructor() {
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange($event?.target['value']);
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
  }

  // value accessor functions
  writeValue(value: any): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
